export var hasUserEnrrolledInAnyDeliveryMethod = function (formDeliveryMethods) {
    return Object.keys(formDeliveryMethods).some(function (delKey) {
        return formDeliveryMethods[delKey].enrolled;
    });
};
export var getPostFixData = function (isAlertOn, hasEnrrolled, isSubFunctionPostFix) {
    if (isSubFunctionPostFix === void 0) { isSubFunctionPostFix = false; }
    var postFix = '';
    if (isAlertOn && !hasEnrrolled) {
        postFix = isSubFunctionPostFix ? 'unenroll' : 'turnoff';
    }
    else if (isAlertOn) {
        postFix = isSubFunctionPostFix ? 'modify' : 'save';
    }
    else {
        postFix = 'enroll';
    }
    return postFix;
};
export var getDataChannelsPostFix = function (deliveryMethodLabels, keyword) {
    if (deliveryMethodLabels.length <= 0) {
        return '';
    }
    if (deliveryMethodLabels.length <= 1) {
        return "".concat(keyword, ": ").concat(deliveryMethodLabels.join(''), " only");
    }
    return "".concat(keyword, ": ").concat(deliveryMethodLabels.join(' and '));
};
export var getDeliveryChannels = function (currentDeliveryMethods, formDeliveryMethods) {
    var enrolledDeliveryMethodKeys = currentDeliveryMethods
        .map(function (delMeth) { return delMeth.key; })
        .filter(function (methKey) { return formDeliveryMethods[methKey].enrolled; });
    return getDataChannelsPostFix(enrolledDeliveryMethodKeys, 'enroll');
};
export var getModifyDeliveryChannels = function (currentDeliveryMethods, formDeliveryMethods) {
    var changedDeliveryMethodKeys = currentDeliveryMethods
        .map(function (delMeth) { return delMeth.key; })
        .filter(function (methKey) { return formDeliveryMethods[methKey].enrolled; });
    return getDataChannelsPostFix(changedDeliveryMethodKeys, 'modify');
};
export var getDataChannels = function (isAlertOn, hasEnrrolled, modifyDeliveryChannels, enrollDeliveryChannels) {
    if (isAlertOn && !hasEnrrolled) {
        return '';
    }
    if (isAlertOn) {
        return modifyDeliveryChannels;
    }
    return enrollDeliveryChannels;
};
export var getDataMessage = function (hasEnrolled, dataErrors) {
    if (dataErrors.length <= 0 && !hasEnrolled) {
        return '';
    }
    var message = [];
    dataErrors.forEach(function (msg) { return message.push(msg.value); });
    return message.join(' | ');
};
